module.exports = __webpack_public_path__ + "static/media/mushroom.6cf1bef7.png";